// extracted by mini-css-extract-plugin
module.exports = {"heading":"_Home_heading__zq62U","description":"_Home_description__gsXM6","actions":"_Home_actions__R_O5J","posts":"_Home_posts__9pam6","testimonials":"_Home_testimonials__OuUXz"};